import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

/**
 * One page of a project's photos and videos from every folder of its bank,
 * and those in none (a bulletin's, a form's), newest first
 * (`GET /project-bank/:projectId/media`): the gallery view's flat list.
 *
 * A bank user gets every one; a gallery-only user those of the images
 * folder and beneath it that the gallery shows them. A page can come back
 * short, even empty, with more behind it: go on while there is a
 * `nextToken`.
 * @param {string} projectId
 * @param {{nextToken?: ?string}} [options]
 * @returns {Promise<{items: Array<Object>, nextToken: ?string}>}
 */
export const getProjectBankGalleryMedia = async (
  projectId,
  { nextToken } = {}
) => {
  const query = new URLSearchParams();
  if (nextToken) query.set('nextToken', nextToken);
  const queryString = query.toString();

  const apiPath = `project-bank/${projectId}/media${
    queryString ? `?${queryString}` : ''
  }`;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
